



















































// npm
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import ElementQueries from 'css-element-queries';
// store/state/models
import KeyListener from '@/KeyListener';
import Mutations from '@/store/mutations';
import UserGroup from '@/models/UserGroup';
import User from '@/models/User';
import Node from '@/models/Node';
import Connection from '@/models/Connection';
import { PacketType } from '@/models/Packet';
import { SendPacket } from '@/networking/SendPacket';
import Tag from '@/models/Tag';
import Vector2 from '@/models/Vector2';
import Vector3 from '@/models/Vector3';
import Camera from '@/models/DOMCamera';
import TimelineAccessUserData from '@/models/TimelineAccessUserData';
import ColorUtility from '@/util/ColorUtility';
import lerp from '@/util/Lerp';
// views/components
import ConnectionEditor from '@/views/timelineeditor/side-panel/ConnectionEditor.vue';

@Component({
	refs: ['timelineRoot'],
	components: 
	{
        ConnectionEditor
	},
	computed:
	{
		...mapGetters([
			'checkTimelineAdmin',
			'checkTimelineWrite',
            'checkProjectModerate',
            'getConnection'
		]),
	}
})
export default class ConnectionManager extends Vue
{
	@Prop(Node) readonly node! : Node;

	mounted()
	{
		let startTime = Date.now();
		KeyListener.init();
		KeyListener.reset();

		this.unsubscribeFromMutations = this.$store.subscribe((mutation, state) =>
		{
			if (mutation.type == Mutations.updateNodeStart)
			{
				this.needsSort = !this.needsSort;
			}
		});

		setTimeout(() => {
			this.$nextTick(()=>{
			(this.$refs.editorContainer as any).scrollTop = 0;
		})
		}, 50);
	}

	beforeDestroy()
	{
		if (this.unsubscribeFromMutations) this.unsubscribeFromMutations();
		this.unsubscribeFromMutations = null;
		this.destroyed = true;
	}

	deltaTime = 0.016;
	unsubscribeFromMutations : any = null;
	resizeSensor : any = null;
	destroyed = false;
    needsSort = false;
    isAdding = false;
    filter = ''

	get isAnythingSelected()
	{
		return this.selectedObject != null
	}

	get selectedObject()
	{
		return this.$store.state.project.selected;
	}
	
	get sortedrelated()
	{
		let sorted = (this.node == null || this.node.relatedArray == null) ? null : (this.node.relatedArray.sort((a : Node, b : Node) =>
		{
			return a.dateStart.valueOf() - b.dateStart.valueOf();
		}));
		return this.needsSort ? sorted : sorted;
	}

	get relatedconnections()
	{
		return (this.sortedrelated != null) ? this.sortedrelated.map((n : Node) => { return (this as any).getConnection(n.nodeid, this.node.nodeid); }) : null;
    }

    get timeline()
	{
		return this.$store.state.project.activeTimeline;
    }
    
    get nodes()
	{
		return this.$store.getters.nodes;
	}
    
    get timelinenodes()
	{
		let tl = this.timeline;
		if (tl != null)
		{
			var tlnodes = []
			for (const nodeid of tl.nodeIDs)
			{
				//console.log(nodeid);
				tlnodes.push(this.nodes.get(nodeid));
			}
			return tlnodes;
		}
		return null;
	}

	get timelineevents()
	{
		let tl = this.timeline;
		if (tl != null)
		{
			var tlnodes = []
			for (const nodeid of tl.nodeIDs)
			{
				//console.log(nodeid);
				let n = this.nodes.get(nodeid);
				if (n.isEvent())
				{
					tlnodes.push(n);
				}
			}
			return tlnodes;
		}
		return null;
    }
    
    get sortedtimelineevents()
	{
		let sorted = (this.timelineevents == null) ? null : (
            this.timelineevents
            .filter((n) => { return n.name.includes(this.filter.toLowerCase()) || this.filter.includes(n.name.toLowerCase()) })
            .filter((n) => { return !(this.node.relatedArray.includes(n)) && n != this.node; })
            .sort((a : Node, b : Node) =>
            {
                return a.name.localeCompare(b.name);
            })
        );
		return sorted;
	}

	activeElement()
	{
		return document.activeElement;
    }
    
    addConnection(n : Node)
    {
        let conn = new Connection(n.nodeid, this.node.nodeid);
        this.$store.commit(Mutations.setConnection, conn);
        SendPacket(PacketType.NodeAddConnection, 
        {
            nodeid: conn.nodeid1,
            otherid: conn.nodeid2
        });
        this.isAdding = false;
    }

    toggleAdding()
    {
        this.isAdding = !(this.isAdding);
    }
}
